var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.25,
    height: 26.25,
    viewBox: "0 0 26.25 26.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ion-close-circle-outline",
    "data-name": "Icon ion-close-circle-outline",
    transform: "translate(-3.875 -3.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47834",
    "data-name": "Pfad 47834",
    d: "M28.5,16.5a12,12,0,1,0-12,12A12,12,0,0,0,28.5,16.5Z",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#44554c",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47835",
    "data-name": "Pfad 47835",
    d: "M21.159,21.159,13.5,13.5m0,7.659L21.159,13.5",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#44554c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/close-cross.09e9fd83bdb36b2b6dad3dd0dc43225c.svg";
export { ForwardRef as ReactComponent };